import React, { useState, useEffect } from 'react';
import './Fireworks.css';

const COLOR_SETS = [
  ['#ff0000', '#ff6600', '#ffff00'],
  ['#0066ff', '#00ccff', '#ffffff'],
  ['#ff00ff', '#ff66cc', '#ffccff'],
  ['#00ff00', '#66ff00', '#ccff00'],
  ['#ffaa00', '#ff6600', '#ff0000'],
  ['#ff0066', '#ff0000', '#ff6600'],
  ['#00ffcc', '#00ff88', '#66ffcc'],
  ['#ff3399', '#ff66b2', '#ffaadd'],
];

function Fireworks() {
  const [rockets, setRockets] = useState([]);

  useEffect(() => {
    const launch = () => {
      const count = 1 + Math.floor(Math.random() * 2);
      const newRockets = Array.from({ length: count }).map(() => {
        const id = Date.now() + Math.random();
        return {
          id,
          x: 5 + Math.random() * 90,
          y: 5 + Math.random() * 45,
          colors: COLOR_SETS[Math.floor(Math.random() * COLOR_SETS.length)],
          sparks: 14 + Math.floor(Math.random() * 10),
          size: 0.7 + Math.random() * 0.8,
        };
      });

      setRockets(prev => [...prev, ...newRockets]);

      setTimeout(() => {
        const ids = new Set(newRockets.map(r => r.id));
        setRockets(prev => prev.filter(r => !ids.has(r.id)));
      }, 2200);
    };

    const loop = () => {
      launch();
      const delay = 10 + Math.random() * 190;
      timer = setTimeout(loop, delay);
    };
    let timer;
    loop();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fireworks-container">
      {rockets.map(rocket => (
        <div
          key={rocket.id}
          className="firework"
          style={{
            left: `${rocket.x}%`,
            top: `${rocket.y}%`,
            '--fw-scale': rocket.size,
          }}
        >
          {/* Ракета (хвост) */}
          <div className="fw-trail" style={{ '--trail-color': rocket.colors[0] }} />

          {/* Искры */}
          {Array.from({ length: rocket.sparks }).map((_, i) => (
            <div
              key={i}
              className="spark"
              style={{
                '--angle': `${(360 / rocket.sparks) * i}deg`,
                '--color': rocket.colors[i % rocket.colors.length],
                '--delay': `${0.1 + Math.random() * 0.15}s`,
                '--distance': `${105 + Math.random() * 150}px`,
              }}
            />
          ))}

          {/* Вторичные искры */}
          {Array.from({ length: 8 }).map((_, i) => (
            <div
              key={`s2-${i}`}
              className="spark secondary"
              style={{
                '--angle': `${i * 45 + 20}deg`,
                '--color': rocket.colors[(i + 1) % rocket.colors.length],
                '--delay': `${0.3 + Math.random() * 0.2}s`,
                '--distance': `${60 + Math.random() * 75}px`,
              }}
            />
          ))}

          <div className="firework-glow" style={{ '--glow-color': rocket.colors[0] }} />
        </div>
      ))}
    </div>
  );
}

export default Fireworks;
